<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p class="mb-4">
        {{ $t('master.user.description') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <McButtonBack class="ms-3" />

          <b-dropdown
            v-if="phaseOneShow"
            right
            variant="primary"
            menu-class="dropdown-menu-end"
            class="mc-btn-download"
          >
            <!-- For Phase 1 Download will be disabled -->
            <template #button-content>
              {{ $t('global.action.download') }} <i class="mdi mdi-chevron-down ps-2" />
            </template>
            <b-dropdown-item>
              <i class="bx bx-book-content align-middle pe-1" />
              {{ $t('master.user.downloadTable') }}
            </b-dropdown-item>
            <b-dropdown-item>
              <i class="bx bx-book-content align-middle pe-1" />
              {{ $t('master.user.downloadPDF') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>

      <!-- For Phase 1 Filter will be disabled -->
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="mc-table-filter text-end">
            <a
              v-if="phaseOneShow"
              v-b-modal.modal-filter
              class="popup-form btn btn-outline-primary mx-2 mc-btn-filter"
              href="javascript: void(0);"
            >
              <i class="mc-fa icon-outline_filter" />
            </a>
            <b-modal
              v-if="phaseOneShow"
              id="modal-filter"
              class="mc-modal"
              title="Filter"
              size="lg"
              centered
              scrollable
            >
              <div class="card-body mc-modal__filter">
                <form>
                  <div class="mc-modal__filter-item">
                    <label class="mt-3">{{ $t('master.user.position') }}</label>
                    <multiselect
                      v-model="position"
                      :options="['Operational', 'Sales/Marketing', 'Engineering', 'Logistic']"
                      :multiple="true"
                      placeholder="Posisi"
                    />
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>{{ $t('master.user.department') }}</label>
                    <multiselect
                      v-model="department"
                      :options="[
                        'Sales & Delivery',
                        'Sales/Marketing',
                        'IT',
                        'Logistic',
                        'Product',
                        'Engineering',
                      ]"
                      placeholder="Pilih Departemen"
                    />
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>{{ $t('master.user.group') }}</label>
                    <multiselect
                      v-model="userGroup"
                      :options="['System Administrator', 'Jabodetabek', 'Malang', 'Tapal Kuda']"
                      :placeholder="`${$t('global.form.select')} ${$t('master.user.group')}`"
                    />
                  </div>
                </form>
              </div>
              <template #modal-footer="{ cancel }">
                <b-row class="mc-modal__filter-footer">
                  <b-col sm="12" md="8" class="mc-modal__filter-footer-fav">
                    <b-row>
                      <b-col md="6">
                        <b-form-group
                          v-if="!isAddFavorit"
                          id="favorit-label-modal"
                          label="Favorit"
                          label-for="favorit-modal"
                        >
                          <multiselect
                            v-model="fav"
                            :options="['Semua Status', 'Status Aktif', 'Status Nonaktif']"
                            :show-labels="false"
                          />
                        </b-form-group>
                        <b-form-group
                          v-if="isAddFavorit"
                          id="favorit-add-label-modal"
                          label="Favorit"
                          label-for="favorit-modal-add"
                        >
                          <b-form-input
                            id="favorit-modal-add"
                            v-model="addFavorit"
                            placeholder="Nama Favorit"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <McButton
                          v-if="!isAddFavorit"
                          variant="secondary"
                          class="mt-4"
                          icon="mdi-file-plus-outline"
                          :text="$t('master.user.createFavorite')"
                          @click="isAddFavorit = !isAddFavorit"
                        />
                        <McButton
                          v-if="isAddFavorit"
                          variant="secondary"
                          class="mt-4"
                          icon="fa-save"
                          :text="$t('master.user.saveFavorite')"
                        />
                        <i
                          v-if="isAddFavorit"
                          class="fas fa-trash text-danger text-lg mt-4 mx-2"
                          @click="isAddFavorit = !isAddFavorit"
                        />
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
                    <McButton
                      variant="secondary"
                      class="me-3"
                      :text="$t('global.action.close')"
                      @click="cancel()"
                    />
                    <McButton variant="primary" :text="$t('global.action.apply')" />
                  </b-col>
                </b-row>
              </template>
            </b-modal>
            <div class="d-flex justify-content-between">
              <div class="col-6 d-flex gap-5">
                <div class="d-flex justify-content-between">
                  <div class="me-4">
                    {{ $t('navbar.text.userQuota') }}
                  </div>
                  <div>
                    (
                    <span
                      :class="
                        checkAvailability(totalUsers, userLimiter)
                          ? 'fw-bold text-success'
                          : 'fw-bold text-danger'
                      "
                    >
                      {{ totalUsers }}
                    </span>
                    /
                    <span
                      :class="
                        checkAvailability(totalUsers, userLimiter)
                          ? 'fw-bold text-success'
                          : 'fw-bold text-danger'
                      "
                    >
                      {{ userLimiter ?? `&infin;` }}
                    </span>
                    )
                  </div>
                </div>

                <div class="d-flex justify-content-between">
                  <div class="me-4">
                    {{ $t('navbar.text.driverQuota') }}
                  </div>
                  <div>
                    (
                    <span
                      :class="
                        checkAvailability(totalDrivers, driverLimiter)
                          ? 'fw-bold text-success'
                          : 'fw-bold text-danger'
                      "
                    >
                      {{ totalDrivers }}
                    </span>
                    /
                    <span
                      :class="
                        checkAvailability(totalDrivers, driverLimiter)
                          ? 'fw-bold text-success'
                          : 'fw-bold text-danger'
                      "
                    >
                      {{ driverLimiter ?? `&infin;` }}
                    </span>
                    )
                  </div>
                </div>
              </div>
              <div class="col-6 d-flex justify-content-end">
                <McButton
                  v-if="
                    filterSelected.length &&
                    hasAccessAll(['users:update', 'd4a-default-mdpengguna:read'])
                  "
                  id="mc-delete-btn"
                  variant="secondary-red"
                  class="mx-2"
                  :text="$t('global.delete')"
                  icon="icon-outline_trash"
                  @click="openModalDelete"
                />
                <McButton
                  v-if="hasAccessAll(['users:create', 'd4a-default-mdpengguna:read'])"
                  v-b-modal.modal-form-user
                  class="mx-2"
                  icon="icon-fill_plus"
                  :text="$t('global.create')"
                  :disabled="
                    !checkAvailability(totalDrivers, driverLimiter) &&
                    !checkAvailability(totalUsers, userLimiter)
                  "
                  @click="addUser"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
            <h6 v-if="filterSelected.length" class="mc-row-check">
              <span class="badge btn-success">{{ filterSelected.length }}</span>
              {{ $t('global.selectedRows') }}.
              <a class="color-primary" @click="clearCheck">{{ $t('global.action.clearAll') }}</a>
            </h6>
          </div>

          <!-- Search -->
          <div class="ol-sm-8 col-md-8 d-flex flex-row-reverse mc-table-view-wrapper">
            <div class="mc-table-view">
              <p class="mc-label">
                {{ $t('global.action.show') }}
              </p>
              <multiselect
                v-model="show_model"
                :options="show"
                :multiple="true"
                :placeholder="$t('global.allColumn')"
                track-by="label"
                label="label"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  {{ option.name }}
                </template>
              </multiselect>
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label
                  class="d-inline-flex align-items-center mc-table-view__search"
                  @click="focusSearch"
                >
                  <i class="mc-fa fas fa-search" />
                  <b-form-input
                    ref="searchInput"
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="ms-2"
                    @input="selectAll = false"
                  />
                </label>
              </div>
            </div>
          </div>
          <!-- End search -->
        </div>

        <!-- Table -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :fields="visibleFields"
            :items="canLoginUsers"
            sort-by="fullname"
            class="datatables"
            responsive="lg"
            empty-table
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :empty-text="$t('global.emptyTable')"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            :busy="$apollo.queries.users.loading"
            @filtered="onFiltered"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle" />
              </div>
            </template>

            <template #head(check)>
              <div class="form-check">
                <input
                  v-model="selectAll"
                  class="form-check-input me-1"
                  type="checkbox"
                  value="all"
                  @input="toggleAll"
                />
              </div>
            </template>

            <template #cell(check)="data">
              <div class="form-check">
                <input
                  v-model="filterSelected"
                  class="form-check-input me-1"
                  type="checkbox"
                  :value="data.item.userId"
                  :disabled="cannotDelete(data.item.userId)"
                  @input="checkTable"
                />
              </div>
            </template>

            <template #cell(email)="data">
              <strong class="text-primary" @click="onRowClicked(data.item)">
                <span v-if="data.item.isEmailVerified">
                  <i class="mc-fa icon-fill_check-seal me-1 mc-user-icon--verified" />
                </span>
                <span v-else-if="data.item.email">
                  <i class="mc-fa icon-fill_alert-triangle me-1 mc-user-icon--unverified" />
                </span>
                {{ data.item.email || '-' }}
              </strong>
            </template>

            <template #cell(phoneNo)="data">
              <strong class="text-primary" @click="onRowClicked(data.item)">
                <span v-if="data.item.isPhoneVerified">
                  <i class="icon-fill_check-seal me-1 mc-user-icon--verified" />
                </span>
                <span v-else-if="data.item.phoneNo">
                  <i class="icon-fill_alert-triangle me-1 mc-user-icon--unverified" />
                </span>
                {{ data.item.phoneNo ? `+${data.item.phoneNo}` : '-' }}
              </strong>
            </template>

            <template #cell(groupName)="data">
              {{ data.item.groups.map((entry) => entry.name).join(', ') }}
            </template>

            <template #cell(department)="data">
              {{ data.item.position ? data.item.position.departmentName : 'No Department' }}
            </template>

            <template #cell(position)="data">
              {{ data.item.position ? data.item.position.name : 'No Position' }}
            </template>

            <template #cell(lastLogin)="data">
              <p class="my-0">
                {{ data.item.lastLogin ? momentDateShortMonth(data.item.lastLogin) : '-' }}
              </p>
              <p class="text-muted my-0">
                {{ data.item.lastLogin ? momentTime(data.item.lastLogin) : '' }}
              </p>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t('global.show') }}
                <b-form-select
                  v-model="perPage"
                  class="form-select form-select-sm"
                  size="sm"
                  :options="pageOptions"
                />
                {{ $t('global.entry') }}.
                <p>
                  {{ $t('global.show') }}&nbsp;
                  <strong>
                    {{ filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0 }}
                  </strong>
                  &nbsp;{{ $t('global.object.to') }}&nbsp;
                  <strong>{{ Math.min(filteredItems.length, currentPage * perPage) }}</strong>
                  &nbsp;{{ $t('global.object.of') }}&nbsp;
                  <strong>{{ filteredItems.length }}</strong>
                  &nbsp;{{ $t('global.entry') }}.
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage"
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Form User - Yang perlu diperbaiki -->
    <b-modal
      id="modal-form-user"
      class="mc-modal mc-user-modal"
      :title="$t('master.user.newUser')"
      size="lg"
      centered
      scrollable
      footer-class="d-flex justify-content-between"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <div class="card-body ps-2">
        <form @submit.stop.prevent="handleSubmit">
          <!-- Alert untuk limiter - hanya tampil saat create -->
          <McAlert
            v-if="
              !checkAvailability(totalDrivers, driverLimiter) ||
              !checkAvailability(totalUsers, userLimiter)
            "
            class="mb-3 gap-0 align-items-md-center"
            style="max-width: -webkit-fill-available; height: 38px"
            variant="info"
            :text="getLimiterInfoText()"
            iconVariant="outline"
            withIcon
          />

          <!-- User Information Section -->
          <div class="mb-4 pb-1 border-bottom">
            <h5 class="text-dark fw-bold">
              {{ $t('master.user.userInformation.title') }}
            </h5>
            <p class="text-muted mb-3">
              {{ $t('master.user.userInformation.description') }}
            </p>

            <!-- User Type Radio - hanya tampil saat create -->
            <div class="mb-3">
              <label class="form-label">{{ $t('master.user.userType') }}</label>
              <b-form-group>
                <b-form-radio
                  v-model="form.isEmployee"
                  plain
                  disabled
                  value="true"
                  inline
                  class="me-4"
                >
                  {{ $t('master.karyawan') }}
                </b-form-radio>
                <b-form-radio v-model="form.isDriver" plain disabled value="true" inline>
                  {{ $t('master.driver') }}
                </b-form-radio>
              </b-form-group>
            </div>

            <!-- Name Selection -->
            <div class="mb-3">
              <label class="form-label">{{ $t('master.user.name') }}</label>
              <multiselect
                v-model="form.fullname"
                :options="nameOptions"
                :placeholder="$t('master.user.selectName')"
                label="fullname"
                :class="{
                  'is-invalid': $v.form.fullname.$error,
                }"
                group-values="users"
                group-label="department"
                :group-select="false"
                @input="changeFullname"
              />
              <div v-if="!$v.form.fullname.$error" class="custom-input-help-text input-md">
                <label class="custom-required-help-text">
                  <span>* </span>{{ $t('global.validation.required') }}
                </label>
              </div>
              <div v-if="$v.form.fullname.$error" class="invalid-feedback">
                <span v-if="!$v.form.fullname.required">
                  {{ $t('master.user.name') }} {{ $t('global.validation.required') }}
                </span>
              </div>
            </div>

            <!-- Group Selection -->
            <div class="mb-3">
              <label class="form-label">{{ $t('master.user.group') }}</label>
              <multiselect
                ref="groupOptions"
                v-model="form.groups"
                :options="ugroups.ugroups"
                :placeholder="`${$t('global.form.select')} ${$t('master.user.group')}`"
                label="name"
                track-by="name"
                :class="{
                  'is-invalid': $v.form.groups.$error,
                }"
                autocomplete="off"
                :disabled="disabledTmsUserGroupAccess"
                @input="changeGroup"
              />
              <div v-if="!$v.form.groups.$error" class="custom-input-help-text input-md">
                <label class="custom-required-help-text">
                  <span>* </span>{{ $t('global.validation.required') }}
                </label>
              </div>
              <div v-if="$v.form.groups.$error" class="invalid-feedback">
                <span v-if="!$v.form.groups.required">
                  {{ $t('master.user.group') }} {{ $t('global.validation.required') }}
                </span>
              </div>
            </div>
          </div>

          <!-- Contact Information Section -->
          <div class="mb-4 pb-1 border-bottom">
            <h5 class="text-dark fw-bold">
              {{ $t('master.user.contactInformation.title') }}
            </h5>
            <p class="text-muted mb-3">
              {{ $t('master.user.contactInformation.description') }}
            </p>

            <!-- Phone Number -->
            <div class="mb-4">
              <label class="form-label">
                {{ $t('master.user.phoneNumber') }}
              </label>
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <McInputNumber
                    id="phone_number"
                    v-model="form.phoneNo"
                    :invalidMsg="$t('master.user.phoneFormat')"
                    :placeholder="$t('master.user.phoneNumber')"
                    :disabled="
                      (form.isPhoneVerified && !phoneEditEnabled) ||
                      (isAnyFieldEditing && !phoneEditEnabled)
                    "
                    @onChange="(val) => (form.phoneNo = val)"
                    :class="{
                      'is-invalid': $v.form.phoneNo.$error,
                    }"
                    @blur="$v.form.phoneNo.$touch()"
                  />
                  <div v-if="$v.form.phoneNo.$error" class="invalid-feedback">
                    <span v-if="!$v.form.phoneNo.minLength">
                      {{ $t('master.user.validation.minLength', { min: 8 }) }}
                    </span>
                    <span v-else-if="!$v.form.phoneNo.maxLength">
                      {{ $t('master.user.validation.maxLength', { max: 15 }) }}
                    </span>
                    <span v-else-if="!$v.form.phoneNo.phoneNumber">
                      {{ $t('master.user.validation.phoneNumber') }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Email -->
            <div class="mb-3">
              <label class="form-label">
                {{ $t('navbar.dropdown.megaMenu.application.list.email') }}
              </label>
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <b-form-input
                    v-model="form.email"
                    :placeholder="$t('master.user.placeholderEmail')"
                    :disabled="
                      (form.isEmailVerified && !emailEditEnabled) ||
                      (isAnyFieldEditing && !emailEditEnabled)
                    "
                    :class="{
                      'is-invalid': $v.form.email.$error,
                    }"
                    @blur="$v.form.email.$touch()"
                  />
                  <div v-if="$v.form.email.$error" class="invalid-feedback">
                    <span v-if="!$v.form.email.maxLength">
                      {{ $t('master.user.validation.maxLength', { max: 100 }) }}
                    </span>
                    <span v-else-if="!$v.form.email.email">
                      {{ $t('master.user.validation.email') }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Password Section - hanya tampil saat create -->
          <div :class="{ 'mb-4 pb-1 border-bottom': form.isDriver }">
            <h5 class="text-dark fw-bold">
              {{ $t('master.user.accessVerification.title') }}
            </h5>
            <!-- Paragraf ini tidak perlu indentasi, biarkan sejajar dengan judul -->
            <p class="text-muted mb-3">
              {{ $t('master.user.accessVerification.description') }}
            </p>
            <!-- Div ini tidak perlu indentasi, biarkan sejajar dengan judul -->
            <b-form-group>
              <!-- WhatsApp Option -->
              <div
                class="mc-user-modal__password-method-card mb-3"
                :class="{
                  'mc-user-modal__password-method-card--selected':
                    form.setVerification === 'phoneNumber' && form.phoneNo,
                  'mc-user-modal__password-method-card--disabled': !form.phoneNo,
                }"
                @click="form.phoneNo && (form.setVerification = 'phoneNumber')"
              >
                <div class="d-flex align-items-center justify-content-between p-3">
                  <div class="d-flex align-items-center">
                    <b-form-radio
                      v-model="form.setVerification"
                      plain
                      value="phoneNumber"
                      class="me-3"
                      :disabled="!form.phoneNo"
                    />
                    <i
                      class="icon-outline_whatsapp me-3 mc-user-modal__icon-whatsapp"
                      style="font-size: 1.1rem"
                      :class="{ 'mc-user-modal__icon--muted': !form.phoneNo }"
                    />
                    <span :class="{ 'text-muted': !form.phoneNo }">
                      {{ $t('master.user.whatsappTo') }}
                    </span>
                  </div>
                  <span :class="{ 'text-muted': !form.phoneNo }">
                    {{ form.phoneNo ? `+${form.phoneNo}` : '-' }}
                  </span>
                </div>
              </div>

              <!-- Email Option -->
              <div
                class="mc-user-modal__password-method-card mb-3"
                :class="{
                  'mc-user-modal__password-method-card--selected':
                    form.setVerification === 'email' && form.email,
                  'mc-user-modal__password-method-card--disabled': !form.email,
                }"
                @click="form.email && (form.setVerification = 'email')"
              >
                <div class="d-flex align-items-center justify-content-between p-3">
                  <div class="d-flex align-items-center">
                    <b-form-radio
                      v-model="form.setVerification"
                      plain
                      value="email"
                      class="me-3"
                      :disabled="!form.email"
                    />
                    <i
                      class="icon-outline_email me-3 mc-user-modal__icon-email"
                      style="font-size: 1.1rem"
                      :class="{ 'mc-user-modal__icon--muted': !form.email }"
                    />
                    <span :class="{ 'text-muted': !form.email }">
                      {{ $t('master.user.emailTo') }}
                    </span>
                  </div>
                  <span :class="{ 'text-muted': !form.email }">
                    {{ form.email || '-' }}
                  </span>
                </div>
              </div>
            </b-form-group>
          </div>
          <!-- Direct Set Option with Toggle - Only show for Driver -->
          <!-- Div ini tidak perlu indentasi, biarkan McToggle sejajar dengan judul -->
          <div v-if="form.isDriver" class="mb-4">
            <!-- McToggle component for "Atur Kata Sandi" -->
            <McToggle
              v-model="form.togglePasswordDriver"
              :label="$t('master.user.setDriverPassword')"
              placement="left"
              @change="driverPassToggleChange"
            />
            <!-- Paragraf ini perlu di-indentasi agar sejajar dengan label McToggle -->
            <p class="text-muted mb-3 mc-user-modal__sub-section-indent">
              {{ $t('master.user.setPassword.description') }}
            </p>

            <!-- Direct Password Fields - Tampilkan saat toggle diaktifkan -->
            <!-- Div ini perlu di-indentasi agar sejajar dengan label McToggle -->
            <div v-if="form.togglePasswordDriver" class="mt-3 mc-user-modal__sub-section-indent">
              <!-- Password Field -->
              <div class="mb-3">
                <label class="form-label mc-user-modal__required">{{
                  $t('master.user.password')
                }}</label>
                <b-form-group
                  id="input-group-2"
                  class="mc-user-modal__form-password"
                  label-for="input-2"
                >
                  <div class="position-relative">
                    <b-form-input
                      v-if="showPassword"
                      id="input-password"
                      v-model="form.password"
                      type="text"
                      :placeholder="$t('master.user.password')"
                      :class="{
                        'is-invalid': $v.form.password.$invalid,
                      }"
                      autocomplete="off"
                      @focus="onShowTooltip({ key: 'Password' })"
                      @blur="onHideTooltip({ key: 'Password' })"
                    />
                    <b-form-input
                      v-else
                      id="input-password"
                      v-model="form.password"
                      type="password"
                      :placeholder="$t('master.user.password')"
                      :class="{
                        'is-invalid': $v.form.password.$invalid,
                      }"
                      @focus="onShowTooltip({ key: 'Password' })"
                      @blur="onHideTooltip({ key: 'Password' })"
                    />
                    <i
                      class="mc-user-modal__password-toggle"
                      :class="{
                        'icon-outline_eye': showPassword,
                        'icon-outline_eye-off-2': !showPassword,
                      }"
                      @click="togglePassword"
                    />
                  </div>
                  <!-- Password Validation Tooltip -->
                  <div v-if="showTooltipPassword" class="mc-user-modal__tooltip">
                    <ul
                      v-for="(val, idx) in passwordValidationsCases"
                      :key="idx"
                      class="mc-tooltip__bottom list-unstyled my-2"
                    >
                      <li class="mb-2">
                        <i
                          :class="`me-2 icon-fill_${
                            $v.form.password[val] ? 'checkmark' : 'close'
                          }-circle ${
                            $v.form.password[val]
                              ? 'mc-user-modal__icon-success'
                              : 'mc-user-modal__icon-danger'
                          }`"
                        />
                        <label :class="$v.form.password[val] ? 'text-success' : 'text-danger'">
                          {{ $t(`password.${val}`) }}
                        </label>
                      </li>
                    </ul>
                  </div>
                </b-form-group>
              </div>

              <!-- Confirm Password Field -->
              <div class="mb-2">
                <label class="form-label mc-user-modal__required">{{
                  $t('master.user.repeat')
                }}</label>
                <b-form-group
                  id="input-group-3"
                  class="mc-user-modal__form-password"
                  label-for="input-3"
                >
                  <div class="position-relative">
                    <b-form-input
                      v-if="showRepassword"
                      id="input-repassword"
                      v-model="form.repassword"
                      type="text"
                      :disabled="!form.password && form.repassword.length == 0"
                      :placeholder="$t('master.user.repeat')"
                      :class="{
                        'is-invalid': $v.form.repassword.$error || !isPasswordMatched,
                      }"
                      @input="differentPass = false"
                      @focus="onShowTooltip({ key: 'Repassword' })"
                      @blur="onHideTooltip({ key: 'Repassword' })"
                    />
                    <b-form-input
                      v-else
                      id="input-repassword"
                      v-model="form.repassword"
                      type="password"
                      :disabled="!form.password && form.repassword.length == 0"
                      :placeholder="$t('master.user.repeat')"
                      :class="{
                        'is-invalid': $v.form.repassword.$error || !isPasswordMatched,
                      }"
                      @input="differentPass = false"
                      @focus="onShowTooltip({ key: 'Repassword' })"
                      @blur="onHideTooltip({ key: 'Repassword' })"
                    />
                    <i
                      class="mc-user-modal__password-toggle"
                      :class="{
                        'icon-outline_eye': showRepassword,
                        'icon-outline_eye-off-2': !showRepassword,
                      }"
                      @click="toggleRepassword"
                    />
                  </div>
                  <!-- Password Match Tooltip -->
                  <div
                    v-if="showTooltipRepassword && form.password"
                    class="mc-user-modal__tooltip-repassword"
                  >
                    <i
                      :class="`me-2 icon-fill_${isPasswordMatched ? 'checkmark' : 'close'}-circle ${
                        isPasswordMatched
                          ? 'mc-user-modal__icon-success'
                          : 'mc-user-modal__icon-danger'
                      }`"
                    />
                    <label :class="isPasswordMatched ? 'text-success' : 'text-danger'">
                      {{ $t(`password.matched`) }}
                    </label>
                  </div>
                </b-form-group>
              </div>
            </div>
          </div>
        </form>
      </div>

      <template #modal-footer="{ cancel }">
        <div></div>
        <div>
          <McButton
            variant="secondary"
            class="me-3"
            :text="$t('global.action.cancel')"
            @click="cancel()"
          />

          <McButton
            variant="primary"
            :disabled="
              isSubmit ||
              (form.togglePasswordDriver
                ? $v.form.password.$invalid || $v.form.repassword.$invalid || !isPasswordMatched
                : form.setVerification === 'email'
                ? !form.email
                : !form.phoneNo)
            "
            :text="$t('global.action.save')"
            @click="handleOk"
          />
        </div>
      </template>
    </b-modal>

    <!-- Modal for Delete Confirmation -->
    <b-modal
      id="modal-delete-user"
      class="mc-modal"
      title="Hapus"
      size="md"
      centered
      scrollable
      @hidden="resetModal"
      @ok="handleOk"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>{{ $t('global.confirmDelete1') }} {{ $t('global.confirmDelete2') }}</p>
        <b-list-group>
          <b-list-group-item v-for="user in deleteUser" :key="user.userId">
            {{ user.email }}
          </b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <McButton variant="secondary" class="me-2" :text="$t('global.no')" @click="cancel()" />
            <McButton variant="primary" :text="$t('global.yes')" @click="toDelete" />
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Modal Component -->
    <UserActionModal
      :action-type="modalActionType"
      :user-data="selectedUserData"
      :initial-form="modalInitialForm"
      @submit="handleAction"
      @reset="resetModal"
    />
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import 'multi-range-slider-vue/MultiRangeSliderBarOnly.css'
import Multiselect from 'vue-multiselect'
import { Helper } from '@/mixin/helper'
import { required, email, requiredIf, minLength, maxLength } from 'vuelidate/lib/validators'
import Swal from 'sweetalert2'
import { GET_USER, GET_USERS, UPDATE_USER } from '@/services/api/master/user'
import { GET_USER_GROUP } from '@/services/api/setting/user/userGroup'
import { GET_EMPLOYEES } from '@/services/api/master/employees'
import { mapGetters } from 'vuex'
import * as invitationApi from '@/services/rest-api-identity/lib/invitation/invitation'
import * as middlewareSpec from '@/services/rest-api-identity/lib/limiter/middlewareSpec'
import McButton from '@/components/McButton'
import McButtonBack from '@/components/McButtonBack'
import McAlert from '@/components/McAlert'
import McInputNumber from '@/components/McInputNumber'
import McToggle from '@/components/McToggle'
import * as verificationApi from '@/services/rest-api-identity/lib/verification/verification'
import UserActionModal from './components/UserActionModal.vue'

// Custom phone number validator
const phoneNumber = (value) => {
  if (!value) return true

  const cleanPhone = value.replace(/\D/g, '')

  // Pola:
  // 1. Boleh diawali 0 lalu diikuti [1-9]...
  // 2. Atau diawali kode negara (1–3 digit) tapi setelahnya tidak boleh '0'
  const pattern = /^(0[1-9]\d{7,11}|[1-9]\d{0,2}[1-9]\d{6,10})$/

  return pattern.test(cleanPhone)
}

/**
 * Starter component
 */
export default {
  page: {
    title: 'Data Pengguna',
    meta: [{ name: 'description', content: appConfig.description }],
  },

  components: {
    Layout,
    PageHeader,
    Multiselect,
    McButton,
    McButtonBack,
    McAlert,
    McInputNumber,
    McToggle,
    UserActionModal,
  },

  mixins: [Helper],

  apollo: {
    users: {
      query: GET_USERS,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          this.totalRows = data.users.users.length
          this.filteredItems = data.users.users
        }
      },
    },
    ugroups: {
      fetchPolicy: 'no-cache',
      query: GET_USER_GROUP,
      variables() {
        return {
          filter: {
            pagination: {
              page: 1,
              show: 9999,
            },
            showSuperAdmin: false,
            showSuperUserOperational: this.hasAccessAll([
              'tms-user-group:create',
              'tms-user-group:delete',
              'tms-user-group:read',
              'tms-user-group:update',
            ]),
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          this.ugroups.ugroups = data.ugroups.ugroups.data
        }
      },
    },
    employees: {
      query: GET_EMPLOYEES,
      fetchPolicy: 'no-cache',
      result({ data, loading }) {
        if (!loading) {
          this.employees.employees = data.employees.employees
        }
      },
    },
  },

  data() {
    return {
      phaseOneShow: false,
      showPassword: false,
      showRepassword: false,
      phoneEditEnabled: false,
      emailEditEnabled: false,
      originalPhoneNo: null,
      originalEmail: null,
      testLang: this.$i18n.t('global.search'),
      filterSelected: [],
      selectAll: false,
      users: {
        users: [],
      },
      deleteUser: [],
      employees: {
        employees: [],
      },
      ugroups: {
        ugroups: [],
      },
      form: {
        userType: 'karyawan',
        userId: null,
        fullname: null,
        password: '',
        repassword: '',
        isEmployee: false,
        groups: null,
        oldGroups: null,
        isDriver: false,
        email: null,
        phoneNo: null,
        togglePasswordDriver: false,
        toggleVerification: false,
        setVerification: null,
        isPhoneVerified: false,
        isEmailVerified: false,
      },
      filterMonth: '',
      // selected: [],
      position: null,
      department: null,
      userGroup: null,
      userName: null,
      userGroupName: null,
      fav: null,
      isAddFavorit: false,
      addFavorit: null,
      showModal: false,
      show_model: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'name',
      sortDesc: false,
      barMinValueSpeed: 1,
      barMaxValueSpeed: 160,
      barMinValueDegree: 1,
      barMaxValueDegree: 100,
      barMinValueTemp: 1,
      barMaxValueTemp: 100,
      differentPass: false,
      isSubmit: false,
      showPasswordIcon: 'icon-outline_eye-off-2',
      isUserLoggedIn: false,
      INTERNAL_USER_API: null,
      show: [
        { key: 'email', label: 'Email' },
        { key: 'fullname', label: this.$t('master.user.fullname') },
        { key: 'Department', label: this.$i18n.t('master.user.department') },
        { key: 'position', label: this.$i18n.t('master.user.position') },
        { key: 'groupName', label: this.$i18n.t('master.user.group') },
        { key: 'lastLogin', label: this.$i18n.t('master.user.lastLogin') },
      ],
      itemModal: {},
      filteredItems: [],
      userLimiter: null,
      driverLimiter: null,
      showTooltipPassword: false,
      showTooltipRepassword: false,
      passwordValidationsCases: [
        'lowerCase',
        'specialCharacter',
        'upperCase',
        'minimumLength',
        'number',
      ],
      // Track which fields are being edited
      editingFields: new Set(),

      // Store original values for cancel functionality
      originalValues: {},

      // Options for dropdowns
      fullnameOptions: [],
      userGroupOptions: [],

      // New data properties for edit name modal
      isEditNameSubmit: false,
      modalActionType: 'edituser',
      selectedUserData: {},
      modalInitialForm: {},
    }
  },

  validations: {
    form: {
      fullname: { required },
      email: {
        email,
        maxLength: maxLength(100),
      },
      phoneNo: {
        minLength: minLength(8),
        maxLength: maxLength(15),
        phoneNumber,
      },
      groups: { required },
      password: {
        required: requiredIf(function () {
          return this.$store.state.config.mode !== 'development' && this.form.isDriver
        }),
        maxLength: maxLength(50),
        lowerCase: (val) => {
          const lowercaseRegex = /[a-z]/
          return lowercaseRegex.test(val)
        },
        upperCase: (val) => {
          const uppercaseRegex = /[A-Z]/
          return uppercaseRegex.test(val)
        },
        number: (val) => {
          const numberRegex = /\d/
          return numberRegex.test(val)
        },
        specialCharacter: (val) => {
          const specialCharRegex = /[!@#$%^&*(),.?":{}|<>~`[\]\-_+=;'/\\]/
          return specialCharRegex.test(val)
        },
        minimumLength: (val) => {
          return val.length >= 8
        },
      },

      repassword: {
        required: requiredIf(function () {
          return this.$store.state.config.mode !== 'development' && this.form.isDriver
        }),
        minLength: minLength(8),
        maxLength: maxLength(50),
      },
    },
  },

  computed: {
    /**
     * Check if any field is currently being edited
     */
    isAnyFieldEditing() {
      return this.phoneEditEnabled || this.emailEditEnabled
    },

    /**
     * Check if contact field is valid based on selected password method
     */
    isContactFieldValid() {
      // Jika sudah pilih metode, pakai logika lama
      if (this.form.setVerification) {
        if (this.form.setVerification === 'phoneNumber') {
          return this.form.phoneNo && this.form.phoneNo.trim() !== ''
        }
        if (this.form.setVerification === 'email') {
          return this.form.email && this.form.email.trim() !== ''
        }
      }
      // Jika belum pilih metode, enable jika email atau phone sudah diisi
      return (
        (this.form.email && this.form.email.trim() !== '') ||
        (this.form.phoneNo && this.form.phoneNo.trim() !== '')
      )
    },

    listUser() {
      return [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'fullname',
          label: this.$t('master.user.fullname'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'email',
          label: 'Email',
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'phoneNo',
          label: this.$t('master.user.phoneNumber'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'department',
          label: this.$t('master.user.department'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'position',
          label: this.$t('master.user.position'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'groupName',
          label: this.$t('master.user.group'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'lastLogin',
          label: this.$t('master.user.lastLogin'),
          thClass: 'mc-table--50',
          sortable: true,
        },
      ]
    },

    /**
     * Total no. of records
     */
    rows() {
      return this.users.users.length
    },
    title() {
      return this.$i18n.t('master.pengguna')
    },
    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        let result = this.show_model.map((a) => a.key)

        return this.listUser.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.listUser
      }
    },
    canLoginUsers() {
      return this.users.users.filter(function (item) {
        return item.canLogin
      })
    },
    cannotLoginUsers() {
      let users = this.employees.employees.filter(function (item) {
        return !item.canLogin
      })

      let department = users.map(function (item) {
        return item.position && item.position.departmentName
          ? item.position.departmentName
          : 'No Department'
      })
      department = [...new Set(department)]

      let res = []
      for (const iterator of department) {
        let usersDepartment = []
        users.forEach(function (item) {
          let userDepartment =
            item.position && item.position.departmentName
              ? item.position.departmentName
              : 'No Department'
          if (iterator == userDepartment) {
            usersDepartment.push(item)
          }
        })

        res.push({
          department: iterator,
          users: usersDepartment,
        })
      }

      return res
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    limiters() {
      return this.getLimiters()
    },
    password() {
      return this.form.password
    },
    totalDrivers() {
      let drivers = this.canLoginUsers?.filter((e) => {
        if (!e.position) return
        return e.position.name === 'Driver'
      })
      return drivers?.length
    },
    totalUsers() {
      return this.canLoginUsers?.length - this.totalDrivers
    },
    nameOptions() {
      let names = [...this.cannotLoginUsers]
      if (!this.checkAvailability(this.totalDrivers, this.driverLimiter)) {
        const drivers = this.cannotLoginUsers[0]?.users?.filter((e) => !e.isDriver)
        names = []
        names.push({
          departments: this.cannotLoginUsers.departments,
          users: drivers,
        })
      }
      if (!this.checkAvailability(this.totalUsers, this.userLimiter)) {
        const users = this.cannotLoginUsers[0]?.users?.filter((e) => e.isDriver)
        names = []
        names.push({
          department: this.cannotLoginUsers.departments,
          users: users,
        })
      }
      return names
    },
    isPasswordMatched() {
      return this.form.password === this.form.repassword && !this.$v.form.repassword.$invalid
    },
    isPasswordValid() {
      return this.isPasswordMatched && !this.$v.$invalid
    },
    isVerified() {
      return this.form.isEmailVerified || this.form.isPhoneVerified
    },
    disabledTmsUserGroupAccess() {
      if (
        this.hasAccessAll([
          'tms-user-group:create',
          'tms-user-group:delete',
          'tms-user-group:read',
          'tms-user-group:update',
        ])
      ) {
        if (this.isSuperUser()) {
          return false
        }
        return true
      }

      return this.form?.groups?.mgroupId == 0
    },
  },

  watch: {
    limiters: {
      handler: 'handleAsyncLimiter',
      immediate: true,
    },
    password: {
      handler: 'validationPassword',
      immediate: true,
    },

    'form.email': {
      handler(newVal, oldVal) {
        // If email is empty and current selection is email, reset to first available option
        if (newVal !== oldVal) {
          this.resetVerificationMethod()
        }
      },
      immediate: true,
    },

    // Watch for phone number changes
    'form.phoneNo': {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.resetVerificationMethod()
        }
      },
      immediate: true,
    },

    // Watch for user type changes
    'form.isDriver': {
      handler(newVal) {
        // If changed from driver to employee and current selection is directSet, reset
        if (!newVal && this.form.setPassword === 'directSet') {
          this.resetVerificationMethod()
        }
      },
      immediate: true,
    },
    userData: {
      handler(newData) {
        if (newData && Object.keys(newData).length > 0) {
          this.form = { ...this.form, ...newData }
        }
      },
      immediate: true,
    },
  },

  methods: {
    /**
     * Enable field editing for verified fields
     */
    enableFieldEdit(fieldType) {
      if (fieldType === 'phone') {
        this.phoneEditEnabled = true
        // Store original value for cancel
        this.originalPhoneNo = this.form.phoneNo
      } else if (fieldType === 'email') {
        this.emailEditEnabled = true
        // Store original value for cancel
        this.originalEmail = this.form.email
      }
    },

    /**
     * Save field edit
     */
    saveFieldEdit(fieldType) {
      if (fieldType === 'phone') {
        // Validate phone number
        this.$v.form.phoneNo.$touch()
        if (this.$v.form.phoneNo.$invalid) {
          this.$mcToast.error(this.$t('master.user.phoneFormat'))
          return
        }
        this.phoneEditEnabled = false
        this.originalPhoneNo = null
        this.$mcToast.success(this.$t('global.alert.text.phoneNumberUpdated'))
      } else if (fieldType === 'email') {
        // Validate email
        this.$v.form.email.$touch()
        if (this.$v.form.email.$invalid) {
          this.$mcToast.error(this.$t('global.validation.invalidFormatEmail'))
          return
        }
        this.emailEditEnabled = false
        this.originalEmail = null
        this.$mcToast.success(this.$t('global.alert.text.emailUpdated'))
      }
    },

    /**
     * Cancel field edit
     */
    cancelFieldEdit(fieldType) {
      if (fieldType === 'phone') {
        this.form.phoneNo = this.originalPhoneNo
        this.phoneEditEnabled = false
        this.originalPhoneNo = null
      } else if (fieldType === 'email') {
        this.form.email = this.originalEmail
        this.emailEditEnabled = false
        this.originalEmail = null
      }
      // Reset validation state
      this.$v.$reset()
    },

    /**
     * Search the table data with search input
     */
    focusSearch() {
      this.$refs.searchInput.focus()
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    togglePassword() {
      this.showPassword = !this.showPassword
    },

    toggleRepassword() {
      this.showRepassword = !this.showRepassword
    },

    toggleAll(event) {
      let checked = event.target.checked
      let userId = this.getUserId()

      if (checked) {
        for (const iterator of this.filteredItems) {
          this.filterSelected.push(iterator.userId)
        }
        this.filterSelected = [...new Set(this.filterSelected)]
        let index = this.filterSelected.indexOf(userId)
        if (index !== -1) {
          this.filterSelected.splice(index, 1)
        }
      } else {
        for (const iterator of this.filteredItems) {
          let index = this.filterSelected.indexOf(iterator.userId)
          if (index !== -1) {
            this.filterSelected.splice(index, 1)
          }
        }
      }
    },

    checkTable(event) {
      let userId = this.getUserId()
      let total = this.filteredItems.length
      let userIndex = this.filteredItems.findIndex((item) => item.userId === userId)
      if (userIndex == -1) {
        total = this.filteredItems.length
      } else {
        if (this.filter && this.filterSelected.length > 0) {
          total = this.filterSelected.length + 1
        } else {
          total = this.filteredItems.length - 1
        }
      }
      if (event.target.checked) {
        this.filterSelected.push(parseInt(event.target.value))
        let flg = true
        for (const iterator of this.filteredItems) {
          let index = this.filterSelected.indexOf(iterator.userId)
          if (index == -1) {
            flg = false
            break
          }
        }
        if (flg || this.filterSelected.length == total) this.selectAll = true
        else this.selectAll = false
      } else {
        this.selectAll = false
        let index = this.filterSelected.indexOf(parseInt(event.target.value))
        if (index !== -1) {
          this.filterSelected.splice(index, 1)
        }
      }
    },

    async openModalDelete() {
      for (const iterator of this.filterSelected) {
        await this.$apollo
          .query({
            query: GET_USER,
            variables: {
              input: {
                userId: parseInt(iterator),
              },
            },
          })
          .then((res) => {
            let isSuccessful = res.data.user.isSuccessful
            if (isSuccessful) {
              this.deleteUser.push(res.data.user.user)
            }
          })
      }
      this.$bvModal.show('modal-delete-user')
    },

    async toDelete(bvModalEvent) {
      bvModalEvent.preventDefault()
      let promises = []

      for (const iterator of this.filterSelected) {
        let input = {
          userId: iterator,
          oldData: {
            canLogin: true,
          },
          newData: {
            canLogin: false,
          },
        }

        promises.push(
          this.$apollo.mutate({
            mutation: UPDATE_USER,
            variables: {
              input: input,
            },
          })
        )
      }

      await Promise.all(promises)
        .then((res) => {
          this.$apollo.queries.users.refetch()
          this.$apollo.queries.employees.refetch()
          this.clearCheck()
          this.$bvModal.hide('modal-delete-user')
          res.forEach((result) => {
            if (result.data.updateUser.isSuccessful) {
              this.$mcToast.success(this.$t('global.alert.text.delete'))
            } else this.$mcToast.error(result.data.updateUser.message)
          })
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e)
        })
    },

    resetModal() {
      this.$v.$reset()
      this.form = {
        userType: 'karyawan',
        userId: null,
        fullname: null,
        password: '',
        repassword: '',
        isEmployee: false,
        isDriver: false,
        email: null,
        phoneNo: null,
        groups: null,
        oldGroups: null,
        togglePasswordDriver: false,
        toggleVerification: false,
        setVerification: null,
        isPhoneVerified: false, // Tambahkan ini
        isEmailVerified: false, // Tambahkan ini
      }
      this.isSubmit = false
      this.showPassword = false
      this.phoneEditEnabled = false
      this.emailEditEnabled = false
      this.originalPhoneNo = null
      this.originalEmail = null
      this.isUserLoggedIn = false
      this.deleteUser = []
    },

    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      this.isSubmit = true

      if (this.$v.$invalid) {
        if (
          (this.form.email == '' || this.form.email == null || this.$v.form.email.$invalid) &&
          (this.form.phoneNo == '' || this.form.phoneNo == null || this.$v.form.phoneNo.$invalid)
        ) {
          this.$mcToast.error(this.$t('master.user.emailPhoneNoEmptyError'))
          this.isSubmit = false
          return
        }

        if (!this.form.groups || this.$v.form.groups.$invalid) {
          this.$mcToast.error(this.$t('master.user.groupEmptyError'))
          this.isSubmit = false
          return
        }
      }

      if (this.form.togglePasswordDriver) {
        if (this.$v.$invalid) {
          this.$v.$touch()
          this.isSubmit = false
          return
        }
        if (this.form.password !== this.form.repassword) {
          this.differentPass = true
          this.isSubmit = false
          return
        }
        if (!this.isPasswordValid && !this.form.isCheckedPassword) {
          this.$mcToast.error(this.$t('master.user.falsePassFormat'))
          this.isSubmit = false
          return
        }
      }

      let passwordChange = {}
      if (this.form.password != '' && this.form.password != null) {
        passwordChange = { password: this.form.password }
      }

      let newGroups = this.form.groups ? this.form.groups.id : []
      let oldGroups = this.form.oldGroups ? this.form.oldGroups.id : []

      let input = {
        userId: this.form.userId,
        oldData: {
          groups: oldGroups,
          canLogin: false,
          ...passwordChange,
        },
        newData: {
          groups: newGroups,
          canLogin: true,
          ...passwordChange,
          email: this.form.email,
          phoneNo: this.form.phoneNo,
        },
      }

      this.$apollo
        .mutate({
          mutation: UPDATE_USER,
          variables: {
            input: input,
          },
        })
        .then(async (response) => {
          let errStatus = response.data.updateUser?.status
          if (errStatus == 402) {
            this.$bvModal.hide('modal-form-user')
            return Swal.fire({
              title: 'Gagal Simpan',
              text: 'Kuota pengguna telah terpenuhi',
              imageUrl: require(`@/assets/images/alert-report-danger.png`),
              confirmButtonText: 'Tutup',
            })
          }

          if (response.data.updateUser.isSuccessful) {
            if (this.form.togglePasswordDriver) {
              if (this.form.setVerification === 'phoneNumber' && this.form.phoneNo) {
                await this.sendVerification(this.form.userId, 'phone', this.form.phoneNo)
              } else if (this.form.setVerification === 'email' && this.form.email) {
                await this.sendVerification(this.form.userId, 'email', this.form.email)
              }
            } else {
              if (this.form.setVerification === 'phoneNumber' && this.form.phoneNo) {
                await this.sendInvitation(this.form.userId, 'phone')
              } else if (this.form.setVerification === 'email' && this.form.email) {
                await this.sendInvitation(this.form.userId, 'email')
              }
            }
            this.$apollo.queries.users.refetch()
            this.$apollo.queries.employees.refetch()
            this.$mcToast.success(this.$t('liveView.text.dataSaved'))
            this.$bvModal.hide('modal-form-user')
            this.isSubmit = false
          } else {
            this.isSubmit = false
            return this.$mcToast.error(response.data.updateUser.message)
          }
        })
    },

    async sendInvitation(userId, type) {
      try {
        const INTERNAL_USER_API =
          process.env.VUE_APP_ENV === 'production'
            ? process.env.VUE_APP_INTERNAL_USER_PROD_API
            : process.env.VUE_APP_INTERNAL_USER_API

        const res = await invitationApi.sendInvitationUser({
          resource_url: `${INTERNAL_USER_API}${userId}`,
          invitation_type: type,
        })

        if (!res.status) {
          return null
        }
        return res
      } catch (err) {
        console.error('sendInvitation error', err)
        return null
      }
    },

    async sendVerification(userId, type, data) {
      try {
        const INTERNAL_USER_API =
          process.env.VUE_APP_ENV === 'production'
            ? process.env.VUE_APP_INTERNAL_USER_PROD_API
            : process.env.VUE_APP_INTERNAL_USER_API

        const payload = {
          resource_url: `${INTERNAL_USER_API}${userId}`,
          verification_type: type,
        }

        if (type === 'phone') {
          payload.phone_no = data
        } else if (type === 'email') {
          payload.email = data
        }

        const res = await verificationApi.sendVerificationUser(payload)

        if (!res.status) {
          return null
        }
        return res
      } catch (err) {
        console.log('sendVerification error', err)
        return null
      }
    },

    handleSubmit() {
      this.$nextTick(() => {
        this.$bvModal.hide('modal-form-user')
      })
    },

    async handleAction(payload) {
      if (payload.actionType === 'edituser') {
        let passwordChange = {}
        if (payload.form.password != '' && payload.form.password != null) {
          passwordChange = { password: payload.form.password }
        }
        let newGroups = payload.form.groups ? payload.form.groups.id : []
        let oldGroups = payload.form.oldGroups ? payload.form.oldGroups.id : []
        let input = {
          userId: payload.form.userId,
          oldData: {
            groups: oldGroups,
            canLogin: false,
            ...passwordChange,
          },
          newData: {
            groups: newGroups,
            canLogin: true,
            ...passwordChange,
            email: payload.form.email,
            phoneNo: payload.form.phoneNo,
            isPhoneVerified: payload.form.isPhoneVerified,
            isEmailVerified: payload.form.isEmailVerified,
          },
        }
        this.$apollo
          .mutate({
            mutation: UPDATE_USER,
            variables: { input },
          })
          .then(async (response) => {
            let errStatus = response.data.updateUser?.status
            if (errStatus == 402) {
              this.$bvModal.hide('modal-form-user')
              return Swal.fire({
                title: 'Gagal Simpan',
                text: 'Kuota pengguna telah terpenuhi',
                imageUrl: require(`@/assets/images/alert-report-danger.png`),
                confirmButtonText: 'Tutup',
              })
            }
            if (response.data.updateUser.isSuccessful) {
              if (payload.form.toggleVerification && !payload.form.isSetPassword) {
                if (payload.form.togglePasswordDriver && payload.form.password) {
                  if (payload.form.setVerification === 'phoneNumber' && payload.form.phoneNo) {
                    await this.sendVerification(payload.form.userId, 'phone', payload.form.phoneNo)
                  } else if (payload.form.setVerification === 'email' && payload.form.email) {
                    await this.sendVerification(payload.form.userId, 'email', payload.form.email)
                  }
                } else {
                  if (payload.form.setVerification === 'phoneNumber' && payload.form.phoneNo) {
                    await this.sendInvitation(payload.form.userId, 'phone')
                  } else if (payload.form.setVerification === 'email' && payload.form.email) {
                    await this.sendInvitation(payload.form.userId, 'email')
                  }
                }
              } else if (payload.form.toggleVerification && payload.form.isSetPassword) {
                if (payload.form.setVerification === 'phoneNumber' && payload.form.phoneNo) {
                  await this.sendVerification(payload.form.userId, 'phone', payload.form.phoneNo)
                } else if (payload.form.setVerification === 'email' && payload.form.email) {
                  await this.sendVerification(payload.form.userId, 'email', payload.form.email)
                }
              }
              this.$apollo.queries.users.refetch()
              this.$apollo.queries.employees.refetch()
              this.$mcToast.success(this.$t('liveView.text.dataSaved'))
              this.$bvModal.hide('modal-form-user')
              this.isSubmit = false
            } else {
              this.isSubmit = false
              return this.$mcToast.error(response.data.updateUser.message)
            }
          })
      } else if (payload.actionType === 'setverification') {
        if (payload.form.isSetPassword) {
          if (payload.form.setVerification === 'phoneNumber' && payload.form.phoneNo) {
            const response = await this.sendVerification(
              payload.form.userId,
              'phone',
              payload.form.phoneNo
            )
            this.showActionToast(response, payload.actionType)
          } else if (payload.form.setVerification === 'email' && payload.form.email) {
            const response = await this.sendVerification(
              payload.form.userId,
              'email',
              payload.form.email
            )
            this.showActionToast(response, payload.actionType)
          }
        } else {
          if (payload.form.setVerification === 'phoneNumber' && payload.form.phoneNo) {
            const response = await this.sendInvitation(payload.form.userId, 'phone')
            this.showActionToast(response, payload.actionType)
          } else if (payload.form.setVerification === 'email' && payload.form.email) {
            const response = await this.sendInvitation(payload.form.userId, 'email')
            this.showActionToast(response, payload.actionType)
          }
        }
      } else if (payload.actionType === 'setpassword') {
        if (payload.form.setVerification === 'phoneNumber' && payload.form.phoneNo) {
          const response = await this.sendInvitation(payload.form.userId, 'phone')
          this.showActionToast(response, payload.actionType)
        } else if (payload.form.setVerification === 'email' && payload.form.email) {
          const response = await this.sendInvitation(payload.form.userId, 'email')
          this.showActionToast(response, payload.actionType)
        } else if (payload.form.setVerification === 'direct') {
          let passwordChange = {}
          if (payload.form.password != '' && payload.form.password != null) {
            passwordChange = { password: payload.form.password }
          }
          let newGroups = payload.form.groups ? payload.form.groups.id : []
          let oldGroups = payload.form.oldGroups ? payload.form.oldGroups.id : []
          let input = {
            userId: payload.form.userId,
            oldData: {
              groups: oldGroups,
              canLogin: false,
              ...passwordChange,
            },
            newData: {
              groups: newGroups,
              canLogin: true,
              ...passwordChange,
              email: payload.form.email,
              phoneNo: payload.form.phoneNo,
            },
          }
          this.$apollo
            .mutate({
              mutation: UPDATE_USER,
              variables: { input },
            })
            .then((response) => {
              let errStatus = response.data.updateUser?.status
              if (errStatus == 402) {
                this.$bvModal.hide('modal-form-user')
                return Swal.fire({
                  title: 'Gagal Simpan',
                  text: 'Kuota pengguna telah terpenuhi',
                  imageUrl: require(`@/assets/images/alert-report-danger.png`),
                  confirmButtonText: 'Tutup',
                })
              }
              if (response.data.updateUser.isSuccessful) {
                this.$apollo.queries.users.refetch()
                this.$apollo.queries.employees.refetch()
                this.$mcToast.success(this.$t('liveView.text.dataSaved'))
                this.$bvModal.hide('modal-form-user')
                this.isSubmit = false
              } else {
                this.isSubmit = false
                return this.$mcToast.error(response.data.updateUser.message)
              }
            })
        }
      }
    },

    showActionToast(response, actionType) {
      if (!response) {
        this.$mcToast.error(this.$t('global.alert.text.internalServerError'))
        return
      }

      if (response.status) {
        if (actionType === 'setverification') {
          this.$mcToast.success(
            response.message || this.$t('master.user.setVerification.action.success')
          )
        } else if (actionType === 'setpassword') {
          this.$mcToast.success(
            response.message || this.$t('master.user.setPassword.action.success')
          )
        }
      } else {
        if (actionType === 'setverification') {
          this.$mcToast.error(
            response.message || this.$t('master.user.setVerification.action.failed')
          )
        } else if (actionType === 'setpassword') {
          this.$mcToast.error(response.message || this.$t('master.user.setPassword.action.failed'))
        }
      }
    },

    onRowClicked(item) {
      this.openModal(item, 'edituser')
    },

    addUser() {
      this.isSubmit = false
      this.form = {
        userType: 'karyawan',
        userId: null,
        fullname: null,
        password: '',
        repassword: '',
        isCheckedPassword: true,
        isEmployee: false,
        email: null,
        phoneNo: null,
        groups: null,
        oldGroups: null,
        togglePasswordDriver: false,
        setVerification: null,
      }
    },

    changeGroup(item) {
      this.form.groups = item
    },

    resetVerificationMethod() {
      // Reset to first available option
      this.form.setVerification = null
      if (this.form.phoneNo && this.form.phoneNo !== '') {
        this.form.setVerification = 'phoneNumber'
      } else if (this.form.email && this.form.email !== '') {
        this.form.setVerification = 'email'
      }
    },

    // Modify existing changeFullname method
    changeFullname() {
      this.form.userId = this.form.fullname.userId
      this.form.email = this.form.fullname.email
      this.form.isDriver = this.form.fullname.isDriver
      this.form.isEmployee = this.form.isDriver ? false : this.form.fullname.isEmployee
      this.form.phoneNo = this.form.fullname.phoneNo

      const selectedGroupId = this.form.fullname?.groups?.[0]?.id
      if (selectedGroupId) {
        this.form.groups = this.ugroups.ugroups.find((g) => g.id === selectedGroupId) || null
      } else {
        this.form.groups = null
      }

      this.$nextTick(() => this.resetVerificationMethod())
    },

    clearCheck() {
      this.filterSelected = []
      this.selectAll = false
    },

    driverPassToggleChange(isToggleOn) {
      if (isToggleOn) {
        // Paksa validasi ulang dan anggap kosong
        this.form.password = ''
        this.form.repassword = ''
        this.$v.form.password.$reset()
        this.$v.form.repassword.$reset()
        this.form.isCheckedPassword = false
      }
    },

    async getLimiters() {
      try {
        const res = await middlewareSpec.getSpec({
          action: 'UpdateUser',
          kind: 'mutation',
        })
        const obj = {
          user: res?.user?.limit ?? null,
          driver: res?.driver?.limit ?? null,
        }
        return obj
      } catch (error) {
        return error
      }
    },

    async handleAsyncLimiter(getLimitFunction) {
      const limiter = await getLimitFunction
      this.userLimiter = limiter.user
      this.driverLimiter = limiter.driver
    },

    checkAvailability(used, limit) {
      let isAvailable = used < limit
      if (!limit) isAvailable = true
      return isAvailable
    },

    getLimiterInfoText() {
      if (!this.checkAvailability(this.totalUsers, this.userLimiter))
        return this.$t('navbar.text.userExceededInfo')
      if (!this.checkAvailability(this.totalDrivers, this.driverLimiter))
        return this.$t('navbar.text.driverExceededInfo')
    },

    onShowTooltip(obj) {
      if (obj.key === 'Repassword') this.showTooltipRepassword = true
      else if (obj.key === 'Password') this.showTooltipPassword = true
    },

    onHideTooltip(obj) {
      if (obj.key === 'Repassword') this.showTooltipRepassword = false
      else if (obj.key === 'Password') this.showTooltipPassword = false
    },

    isFieldReadonly(fieldName) {
      // If not verified or in create mode, all fields are editable
      if (!this.isVerified || this.isCreateMode) {
        return false
      }

      // If verified, field is readonly unless being edited
      return !this.editingFields.has(fieldName)
    },

    async saveField(fieldName) {
      // Validate specific field
      this.$v.form[fieldName].$touch()

      if (this.$v.form[fieldName].$invalid) {
        this.$mcToast.error(this.$t('validation.field.invalid'))
        return
      }

      try {
        // Call API to update specific field
        const updateData = {
          [fieldName]: this.form[fieldName],
        }

        await this.$api.user.updateField(this.form.id, updateData)

        // Remove from editing fields
        this.editingFields.delete(fieldName)

        // Clear original value
        delete this.originalValues[fieldName]

        this.$mcToast.success(this.$t('user.field.updated'))

        // Emit event for parent component
        this.$emit('field-updated', { field: fieldName, value: this.form[fieldName] })
      } catch (error) {
        this.$mcToast.error(this.$t('user.field.updateError'))
        console.error('Field update error:', error)
      }
    },

    onEmailInput() {
      if (this.$v.form.email.$error) {
        this.$v.form.email.$reset()
      }
    },

    onPhoneInput() {
      let value = this.form.phoneNo.replace(/\D/g, '')

      if (value.length > 15) {
        value = value.substring(0, 15)
      }

      if (value.startsWith('0')) {
        value = value.substring(1)
      }

      this.form.phoneNo = value

      if (this.$v.form.phoneNo.$error) {
        this.$v.form.phoneNo.$reset()
      }
    },

    onUserTypeChange() {
      // Handle user type change logic
      this.form.isDriver = this.form.userType === 'driver'
      this.form.isEmployee = this.form.userType === 'employee'
    },

    // Method untuk check apakah user memiliki verifikasi yang belum selesai
    hasUnverifiedContact(user) {
      const emailUnverified = user.email && !user.isEmailVerified
      const phoneUnverified = user.phoneNo && !user.isPhoneVerified

      return emailUnverified || phoneUnverified
    },

    hasVerifiedContact(user) {
      return user.isPhoneVerified || user.isEmailVerified
    },

    // Method untuk check apakah user adalah driver
    isDriver(user) {
      return user.position?.name === 'Driver'
    },

    openModal(userData, actionType) {
      if (!this.hasAccessAll(['users:update', 'd4a-default-mdpengguna:read'])) return

      this.isSubmit = false
      if (userData.lastLogin != null) {
        this.isUserLoggedIn = true
      }
      this.form.isSetPassword = userData.isSetPassword
      this.form.position = userData.position
      this.form.userType = userData.userType
      this.form.userId = userData.userId
      this.form.fullname = userData.fullname
      this.form.email = userData.email
      this.form.phoneNo = userData.phoneNo
      this.form.password = ''
      this.form.repassword = ''
      this.form.togglePasswordDriver = false
      this.form.toggleVerification = false
      this.form.isDriver = userData.position?.name === 'Driver'
      this.form.isEmployee = this.form.isDriver ? false : userData.isEmployee
      this.form.groups = userData.groups[0]
      this.form.oldGroups = userData.groups[0]
      // Set verification status - untuk demo, set sebagai verified jika ada email/phone
      this.form.isPhoneVerified = userData.isPhoneVerified
      this.form.isEmailVerified = userData.isEmailVerified
      if (userData.isEmailVerified) {
        // Email sudah verified, cek nomor telepon
        if (actionType === 'setverification') {
          if (!userData.phoneNo) {
            this.form.setVerification = null
          } else {
            this.form.setVerification = userData.isPhoneVerified ? null : 'phoneNumber'
          }
        } else if (actionType === 'setpassword') {
          if (userData.email) {
            this.form.setVerification = 'email'
          } else if (userData.phoneNo) {
            this.form.setVerification = userData.isPhoneVerified ? null : 'phoneNumber'
          } else {
            this.form.setVerification = null
          }
        }
      } else {
        // Email belum verified
        if (userData.email) {
          this.form.setVerification = 'email'
        } else if (userData.phoneNo) {
          this.form.setVerification = userData.isPhoneVerified ? null : 'phoneNumber'
        } else {
          this.form.setVerification = null
        }
      }

      this.selectedUserData = this.form
      this.modalActionType = actionType
      this.modalInitialForm = this.form

      // Show modal
      this.$bvModal.show('modal-user-action')
    },
  },
}
</script>
